import { useExperienceContent } from '@hooks/use-server-content';
import { useEffect, useState } from 'react';
import { SecondaryNavContent } from '@sections/secondary-nav/secondary-nav';
import { BRAND, SECONDARY_NAV_COUNTRIES } from '@/constants';
import AppConfigurationService from '@/services/app-configuration-service/app-configuration-service';

const useSecondaryNavContent = () => {
    const [content, setContent] = useState<SecondaryNavContent>(null);
    const appConfig = new AppConfigurationService();
    const countryCode = appConfig.get2LetterCountryCode();
    const [fragmentArgs, setFragmentArgs] = useState({
        category: '',
        name: '',
        componentName: '',
        brandOverride: null,
        ymmServlet: false,
        parentFolderOverride: '',
    });
    const isSecondaryNavRegion =
        SECONDARY_NAV_COUNTRIES.includes(countryCode) &&
        appConfig.brand === BRAND.ford.LONG_NAME;

    useEffect(() => {
        if (isSecondaryNavRegion) {
            setFragmentArgs({
                category: 'secondarynav',
                name: 'secondarynav',
                componentName: 'container',
                brandOverride: null,
                ymmServlet: false,
                parentFolderOverride: 'global-owner',
            });
        }
    }, [isSecondaryNavRegion]);

    const [secondaryNavContent] = useExperienceContent<SecondaryNavContent>(
        fragmentArgs.category,
        fragmentArgs.name,
        fragmentArgs.componentName,
        fragmentArgs.brandOverride,
        fragmentArgs.ymmServlet,
        fragmentArgs.parentFolderOverride
    );
    useEffect(() => {
        if (secondaryNavContent) {
            setContent(secondaryNavContent[':items']?.secondary_nav);
        }
    }, [secondaryNavContent]);

    return content;
};

export default useSecondaryNavContent;
